// modules
import { createAction } from 'redux-actions'

// actions
export const setCaregiverGamificationVault = createAction(
  'SET_CAREGIVER_GAMIFICATION_VAULT'
)
export const setCaregiverGamificationHistory = createAction(
  'SET_CAREGIVER_GAMIFICATION_HISTORY'
)

export const resetCaregiverGamification = createAction(
  'RESET_CAREGIVER_GAMIFICATION'
)
